import { ReturnAssessmentGroupsSchema } from "@redotech/redo-model/return-assessments/assessment-schemas";

export const updateGroup = {
  name: "updateGroup" as const,

  input: ReturnAssessmentGroupsSchema,

  output: ReturnAssessmentGroupsSchema,
};
